import { CircleCheckBig, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export default function SheetReportUpdate({ open, onClose, onUpdate, reportName = 'Inspection de travaux CEE' }) {
    const { t } = useTranslation();
    if (!open) return null;

    return (
        <>
            {/* Overlay */}
            <div className="fixed inset-0 bg-foreground-dark/50 z-[100]" onClick={onClose} />

            {/* Sheet */}
            <div
                className="fixed z-[101] bg-card bottom-0 left-0 right-0 rounded-t-[20px] max-h-[90vh] animate-slide-up md:animate-slide-in-right md:rounded-t-none md:top-0 md:right-0 md:bottom-0 md:left-auto md:max-h-none flex flex-col"
                style={{ width: 'min(90vw, 480px)' }}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-[20px] border-b border-border shrink-0">
                    <h2 className="text-[18px] text-foreground">
                        {t('procedures:mettreAJourLeRapport')}
                    </h2>
                    <Button
                        variant="plain"
                        color="neutral"
                        size="auto"
                        onClick={onClose}
                        className="flex items-center justify-center w-[40px] h-[40px] rounded-[8px] bg-muted border border-border text-foreground hover:bg-border transition-colors"
                    >
                        <X className="h-5 w-5" />
                    </Button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-[20px]">
                    {/* Success Card */}
                    <div className="mb-[24px] bg-success/15 rounded-[16px] p-[20px] flex flex-col items-center text-center">
                        <div className="w-[56px] h-[56px] bg-secondary rounded-full flex items-center justify-center mb-[12px]">
                            <CircleCheckBig className="h-8 w-8 text-foreground" />
                        </div>
                        <h3 className="text-[18px] text-foreground mb-[8px]">
                            {t('procedures:modificationsTerminees')}
                        </h3>
                        <p className="text-[14px] text-muted-foreground">
                            {t('procedures:vousAvezModifie')} <span className="font-semibold text-foreground">{reportName}</span>{t('procedures:vosModificationsOntEteEnregistreesAvecSucces')}
                        </p>
                    </div>
                </div>

                {/* Footer */}
                <div className="border-t border-border p-[20px] shrink-0">
                    <Button
                        variant="soft"
                        color="secondary"
                        size="xxl"
                        onClick={onUpdate}
                        className="w-full px-[20px] py-[14px] rounded-[12px] text-[15px] text-foreground font-medium hover:opacity-90 transition-opacity"
                    >
                        {t('procedures:afficherLeRapport')}
                    </Button>
                </div>
            </div>
        </>
    );
}
